<div class="app-layout">
  <app-header></app-header>

  <main class="app-content">
    <!-- Pending Cancellation Banner (Global) -->
    <div *ngIf="isPendingCancellation" style="margin: 24px auto; padding: 16px; background-color: #fff2f0; border: 1px solid #ffccc7; border-radius: 8px; color: #cf1322; font-weight: 500; display: flex; align-items: center; gap: 8px; max-width: 1200px;">
      <span style="font-size: 20px;">⚠️</span> Yêu cầu huỷ đăng kí của bạn đang đợi duyệt.
    </div>
    
    <router-outlet></router-outlet>

  </main>

  <app-footer></app-footer>
</div>
